
import CONSTANTS from '../constants'
import { getRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'


export const getServicePage = (slug) => (dispatch) => {
    dispatch(addEventLog(slug, CONSTANTS.GET_SERVICES_REQUEST))
    dispatch({ type: CONSTANTS.GET_SERVICES_REQUEST })
    let endpoint = `${APICONFIG.getServicePageUrl}/${slug}`
    let tobject = { slug: slug }
    return getRequest(endpoint).then((res) => {
        let resObject = { ...tobject, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_SERVICES_SUCCESS))
        dispatch({ type: CONSTANTS.GET_SERVICES_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...tobject, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.GET_SERVICES_FAILURE))
        dispatch({ type: CONSTANTS.GET_SERVICES_FAILURE })
        return err
    })
}


